let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("36LoN")).then(() => parcelRequire('Xs7MK'));